import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ResidentDashboardComponent } from './residentdashboard.component';


const routes: Routes = [
  {
    path: '',
    component: ResidentDashboardComponent,
    children: [
      // {
      //   path: 'esign',
      //   component: ESignatureComponent
      // },
    //   {
    //     path: 'createPermission',
    //     component: CreatePermissionComponent
    //   }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class residentdashboardRoutingModule { }
